import React from 'react';
import PropTypes from 'prop-types';
import { logger } from '../utils/logger';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, lastError: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, lastError: error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('React error boundary caught error', {
      message: error?.message,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    const { hasError, lastError } = this.state;
    const { children, fallback } = this.props;
    if (hasError) {
      if (fallback) {
        return fallback;
      }
      return (
        <div style={{ padding: '3rem', color: '#fff', backgroundColor: '#1f1f1f' }}>
          <h1>Something went wrong.</h1>
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            {lastError?.message || 'Unknown error'}
          </pre>
        </div>
      );
    }

    return children;
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

AppErrorBoundary.defaultProps = {
  fallback: null,
};

export default AppErrorBoundary;

